import React from "react";
import { FullScreenDialog, FullScreenDialogProps } from "./FullScreenDialog";
import { JsonViewer } from "./JsonViewer";
interface ViewJsonDialogProps extends FullScreenDialogProps {
	// json to display
	json: object;
}

/**
 * Dialog that displays formatted json
 * @param props
 */
export const ViewJsonDialog = (props: ViewJsonDialogProps) => {
	return (
		<FullScreenDialog {...props} data-testid={"fullscreen-dialog"}>
			<JsonViewer json={props.json} fontSize={14} />
		</FullScreenDialog>
	);
};
